import type { MenuProps } from "antd";
import { Checkbox, Col, Dropdown, Input, Row, Typography } from "antd";
import { useEffect, useState, useRef } from "react";
import "./index.css";

const { Search } = Input;

import CATVBlue from "./../../assets/svgs/CATVBlue.svg";
import WifiIcon from "./../../assets/svgs/WifiIcon.svg";

import { useNavigate, useSearchParams } from "react-router-dom";
import useAxiosPost from "../../hooks/useAxiosPost";
import NetwalaSelect from "../Items/Select/Index";
import ExpiredUsersTable from "../Items/Table/ExpiredUsersTable";
import ExpiringUsersTable from "../Items/Table/ExpiringUsersTable";
import NetwalaUsersTable from "../Items/Table/UsersTable";
import NewConnectionIcon from "../../assets/pngs/NewConnectionIcon.png";
const CustomersComponent = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<ApiWithPagination>("connections/getConnectionsByOwner");

  const [
    postSearchAPi,
    searchApiResponse,
    searchApiError,
    searchApiLoading,
    searchApiMessage,
    searchApiErrorCount,
  ] = useAxiosPost<UserSearchApiProp>("connections/searchConnections");

  const [
    getExpiredConnectionsApi,
    expiredConnectionsApiResponse,
    expiredApiError,
    expiredApiLoading,
  ] = useAxiosPost<ApiWithPagination>("connections/getExpiredConnections");

  const [
    getExpiringConnectionsApi,
    expiringConnectionsApiResponse,
    expiringApiError,
    expiringApiLoading,
  ] = useAxiosPost<ApiWithPagination>("connections/getExpiringConnections");

  const [getIspsApi, ispsApiResponse, ispsApiError, ispsApiLoading] =
    useAxiosPost<ResponseProp>("isps/getISPsByCompanyWithPublicIsps");

  const [getAreasApi, areasApiResponse, areasApiError, areasApiLoading] =
    useAxiosPost<ResponseProp>("areas/getAreasByOwner");

  const [
    getSubAreasApi,
    subAreasApiResponse,
    subAreasApiError,
    subAreasApiLoading,
  ] = useAxiosPost<SubAreasByAreaIDApiProp>("areas/getSubAreasByAreaID");
  const [users, setUsers] = useState<CompanyConnection[]>([]);
  const [searchedUsers, setSearchedUsers] = useState<CompanyConnection[]>([]);
  const [expiredUsers, setExpiredUsers] = useState<ExpiredUsersTableProp[]>([]);
  const [expiringUsers, setExpiringUsers] = useState<ExpiredUsersTableProp[]>(
    []
  );
  const [isSearch, setIsSearch] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  // Initialize filters from URL params
  const [usersFilter, setUsersFilter] = useState<string>(
    searchParams.get("usersFilter") || "1"
  );
  const [expiringFilter, setExpiringFilter] = useState<string>(
    searchParams.get("expiringFilter") || "0"
  );
  const [selectedISP, setSelectedISP] = useState<string | null>(
    searchParams.get("isp") || null
  );
  const [selectedArea, setSelectedArea] = useState<string | null>(
    searchParams.get("area") || null
  );
  const [selectedSubArea, setSelectedSubArea] = useState<string | null>(
    searchParams.get("subArea") || null
  );
  const [pendingPaymentsFilter, setPendingPaymentsFilter] = useState<boolean>(
    searchParams.get("pendingPayments") === "true"
  );
  const [isps, setIsps] = useState<NetwalaSelectOptions[]>([]);
  const [areas, setAreas] = useState<NetwalaSelectOptions[]>([]);
  const [subAreas, setSubAreas] = useState<NetwalaSelectOptions[]>([]);
  // Initialize pageSize and currentPage from URL params
  const [pageSize, setPageSize] = useState<number>(
    Number(searchParams.get("pageSize")) || 50
  );
  const [currentPage, setCurrentPage] = useState<number>(
    Number(searchParams.get("page")) || 1
  );
  const [expiringPageSize, setExpiringPageSize] = useState<number>(50);
  const [expiringCurrentPage, setExpiringCurrentPage] = useState<number>(1);
  const [expiredPageSize, setExpiredPageSize] = useState<number>(50);
  const [expiredCurrentPage, setExpiredCurrentPage] = useState<number>(1);
  const [pagination, setPagination] = useState<PaginationProp>({
    totalPages: 0,
    currentPage: Number(searchParams.get("page")) || 1,
    previousPage: null,
    nextPage: null,
    totalCount: 0,
    pageSize: Number(searchParams.get("pageSize")) || 50,
  });
  const [searchPagination, setSearchPagination] = useState<PaginationProp>({
    totalPages: 0,
    currentPage: 1,
    previousPage: null,
    nextPage: null,
    totalCount: 0,
    pageSize: 100,
  });

  const [expiringPagination, setExpiringPagination] = useState<PaginationProp>({
    totalPages: 0,
    currentPage: 1,
    previousPage: null,
    nextPage: null,
    totalCount: 0,
    pageSize: 50,
  });
  const [expiredPagination, setExpiredPagination] = useState<PaginationProp>({
    totalPages: 0,
    currentPage: 1,
    previousPage: null,
    nextPage: null,
    totalCount: 0,
    pageSize: 50,
  });
  const options = [
    {
      label: "All Connections",
      value: "1",
    },
    {
      label: "Expiring Connections",
      value: "2",
    },
    {
      label: "Expired Connections",
      value: "3",
    },
  ];
  const secondOptions = [
    {
      label: "All Expiring Connections",
      value: "0",
    },
    {
      label: "Today",
      value: "1",
    },
    {
      label: "Tomorrow",
      value: "2",
    },
    {
      label: "This Week",
      value: "3",
    },
  ];
  // Helper function to update URL params
  const updateURLParams = (updates: Record<string, string | null>) => {
    const newParams = new URLSearchParams(searchParams);
    Object.entries(updates).forEach(([key, value]) => {
      if (value === null || value === "" || value === undefined) {
        newParams.delete(key);
      } else {
        newParams.set(key, value);
      }
    });
    setSearchParams(newParams, { replace: true });
  };

  const handleClick = () => {
    navigate(`/create-user`);
  };
  const handleChange = (value: string) => {
    setUsersFilter(value);
    // Reset search state when switching tabs
    setIsSearch(false);
    // Reset to page 1 when switching tabs
    if (Number(value) === 1) {
      setCurrentPage(1);
      updateURLParams({ usersFilter: value, page: "1" });
    } else {
      updateURLParams({ usersFilter: value });
    }
  };
  useEffect(() => {
    if (apiResponse !== null) {
      const data: any = apiResponse.responseData;
      const {
        currentPage: apiCurrentPage,
        totalPages,
        nextPage,
        previousPage,
        totalCount,
        connections,
        pageSize: apiPageSize,
      } = data;
      setPagination({
        currentPage: apiCurrentPage,
        totalPages,
        nextPage,
        previousPage,
        totalCount,
        pageSize: apiPageSize,
      });
      // Don't update state or URL from API response - we control that from user actions
      // Just update the pagination object for display
      setUsers(
        connections.map((item: any): CompanyConnection => {
          return {
            ...item,
            fullName: `${item.firstName} ${item.lastName}`,
          };
        }) || []
      );
    }
  }, [apiResponse]);

  useEffect(() => {
    if (expiredConnectionsApiResponse !== null) {
      const data: any = expiredConnectionsApiResponse.responseData;
      const {
        currentPage,
        totalPages,
        nextPage,
        previousPage,
        totalCount,
        connections,
        pageSize,
      } = data;
      setExpiredPagination({
        currentPage,
        totalPages,
        nextPage,
        previousPage,
        totalCount,
        pageSize,
      });
      setExpiredUsers(
        connections.map((item: any): ExpiredUsersTableProp => {
          return {
            ...item,
            fullName: `${item.firstName} ${item.lastName}`,
          };
        }) || []
      );
    }
  }, [expiredConnectionsApiResponse]);

  useEffect(() => {
    if (expiringConnectionsApiResponse !== null) {
      const data: any = expiringConnectionsApiResponse.responseData;
      const {
        currentPage,
        totalPages,
        nextPage,
        previousPage,
        totalCount,
        connections,
        pageSize,
      } = data;
      setExpiringPagination({
        currentPage,
        totalPages,
        nextPage,
        previousPage,
        totalCount,
        pageSize,
      });
      const _data =
        connections.map((item: any): ExpiredUsersTableProp => {
          return {
            ...item,
            fullName: `${item.firstName} ${item.lastName}`,
          };
        }) || [];
      setExpiringUsers(_data);
    }
  }, [expiringConnectionsApiResponse]);
  useEffect(() => {
    getIspsApi({});
    getAreasApi({});
    // Load sub-areas if area is selected from URL
    const areaFromURL = searchParams.get("area");
    if (areaFromURL) {
      getSubAreasApi({ intPkAreaID: Number(areaFromURL) });
    }
  }, []);

  useEffect(() => {
    if (ispsApiResponse !== null) {
      const data: any = ispsApiResponse.responseData;
      const ispsOptions = data.map((item: any): NetwalaSelectOptions => {
        return {
          value: String(item.intPkIspID),
          label: item.ISPName,
        };
      });
      setIsps([{ label: "All ISPs", value: "" }, ...ispsOptions]);
    }
  }, [ispsApiResponse]);

  useEffect(() => {
    if (areasApiResponse !== null) {
      const data: any = areasApiResponse.responseData;
      const areasOptions = data.map((item: any): NetwalaSelectOptions => {
        return {
          value: String(item.intPkAreaID),
          label: item.areaName,
        };
      });
      setAreas([{ label: "All Areas", value: "" }, ...areasOptions]);
    }
  }, [areasApiResponse]);

  useEffect(() => {
    if (subAreasApiResponse !== null) {
      const data: any = subAreasApiResponse.responseData;
      const subAreasOptions = data.map((item: any): NetwalaSelectOptions => {
        return {
          value: String(item.intPkAreaID),
          label: item.areaName,
        };
      });
      setSubAreas([{ label: "All Sub Areas", value: "" }, ...subAreasOptions]);
    }
  }, [subAreasApiResponse]);

  // Sync state from URL params after options are loaded to ensure labels display correctly
  useEffect(() => {
    // Sync ISP from URL params after ISPs are loaded (only if state doesn't match URL)
    if (isps.length > 0 && ispsApiResponse !== null) {
      const ispFromURL = searchParams.get("isp");
      if (ispFromURL && selectedISP !== ispFromURL) {
        const ispExists = isps.some((isp) => isp.value === ispFromURL);
        if (ispExists) {
          setSelectedISP(ispFromURL);
        }
      }
    }
  }, [isps, ispsApiResponse, searchParams, selectedISP]);

  useEffect(() => {
    // Sync Area from URL params after Areas are loaded (only if state doesn't match URL)
    if (areas.length > 0 && areasApiResponse !== null) {
      const areaFromURL = searchParams.get("area");
      if (areaFromURL && selectedArea !== areaFromURL) {
        const areaExists = areas.some((area) => area.value === areaFromURL);
        if (areaExists) {
          setSelectedArea(areaFromURL);
        }
      }
    }
  }, [areas, areasApiResponse, searchParams, selectedArea]);

  useEffect(() => {
    // Sync SubArea from URL params after SubAreas are loaded (only if state doesn't match URL)
    if (subAreas.length > 0 && subAreasApiResponse !== null) {
      const subAreaFromURL = searchParams.get("subArea");
      if (subAreaFromURL && selectedSubArea !== subAreaFromURL) {
        const subAreaExists = subAreas.some(
          (subArea) => subArea.value === subAreaFromURL
        );
        if (subAreaExists) {
          setSelectedSubArea(subAreaFromURL);
        }
      }
    }
  }, [subAreas, subAreasApiResponse, searchParams, selectedSubArea]);

  // Track previous filter values to detect filter changes (not page/pageSize changes)
  const prevFiltersRef = useRef({
    selectedISP,
    selectedArea,
    selectedSubArea,
    expiringFilter,
    usersFilter,
    pendingPaymentsFilter,
  });

  useEffect(() => {
    const filters: any = {};
    const activeFilter = Number(usersFilter);

    // Check if filters changed (excluding page and pageSize changes)
    const filtersChanged =
      prevFiltersRef.current.selectedISP !== selectedISP ||
      prevFiltersRef.current.selectedArea !== selectedArea ||
      prevFiltersRef.current.selectedSubArea !== selectedSubArea ||
      prevFiltersRef.current.expiringFilter !== expiringFilter ||
      prevFiltersRef.current.usersFilter !== usersFilter ||
      prevFiltersRef.current.pendingPaymentsFilter !== pendingPaymentsFilter;

    // Set page based on active tab and filter changes
    if (activeFilter === 1) {
      // All Connections tab
      if (filtersChanged) {
        setCurrentPage(1);
        updateURLParams({ page: "1" });
        filters.page = 1;
      } else {
        filters.page = currentPage;
      }
    } else if (activeFilter === 2) {
      // Expiring Connections tab
      if (filtersChanged) {
        setExpiringCurrentPage(1);
        filters.page = 1;
      } else {
        filters.page = expiringCurrentPage;
      }
    } else if (activeFilter === 3) {
      // Expired Connections tab
      if (filtersChanged) {
        setExpiredCurrentPage(1);
        filters.page = 1;
      } else {
        filters.page = expiredCurrentPage;
      }
    } else {
      filters.page = 1;
    }

    if (selectedISP) filters.intPkIspID = Number(selectedISP);
    if (selectedSubArea) {
      filters.intPkAreaID = Number(selectedSubArea);
    } else if (selectedArea) {
      filters.intPkAreaID = Number(selectedArea);
    }
    if (pendingPaymentsFilter) {
      filters.pendingPayments = true;
    }

    // Only load data for the active tab
    if (activeFilter === 1) {
      // All Connections tab
      postApiData({ ...filters, pageSize });
    } else if (activeFilter === 2) {
      // Expiring Connections tab
      getExpiringConnectionsApi({
        ...filters,
        filter: Number(expiringFilter),
        pageSize: expiringPageSize,
      });
    } else if (activeFilter === 3) {
      // Expired Connections tab
      getExpiredConnectionsApi({ ...filters, pageSize: expiredPageSize });
    }

    // Update previous filter values (excluding pageSize and currentPage)
    prevFiltersRef.current = {
      selectedISP,
      selectedArea,
      selectedSubArea,
      expiringFilter,
      usersFilter,
      pendingPaymentsFilter,
    };
  }, [
    selectedISP,
    selectedArea,
    selectedSubArea,
    expiringFilter,
    usersFilter,
    pendingPaymentsFilter,
    pageSize,
    currentPage,
    expiringPageSize,
    expiringCurrentPage,
    expiredPageSize,
    expiredCurrentPage,
  ]);
  const getActiveUsersTable = (activeOption: number) => {
    switch (activeOption) {
      case 1:
        return (
          <NetwalaUsersTable
            isLoading={apiLoading || searchApiLoading}
            users={isSearch === true ? searchedUsers : users}
            pagination={isSearch === true ? searchPagination : pagination}
            handlePageSwitch={handleAllUsersPageSwitch}
            handlePageSizeChange={handleAllUsersPageSizeChange}
          />
        );
      case 2:
        return (
          <ExpiringUsersTable
            isLoading={expiringApiLoading || searchApiLoading}
            users={isSearch === true ? (searchedUsers as any) : expiringUsers}
            pagination={expiringPagination}
            handlePageSwitch={handleExpiringUsersPageSwitch}
            handlePageSizeChange={handleExpiringUsersPageSizeChange}
          />
        );
      case 3:
        return (
          <ExpiredUsersTable
            isLoading={expiredApiLoading || searchApiLoading}
            users={isSearch === true ? (searchedUsers as any) : expiredUsers}
            pagination={expiredPagination}
            handlePageSwitch={handleExpiredUsersPageSwitch}
            handlePageSizeChange={handleExpiredUsersPageSizeChange}
          />
        );
    }
  };
  const handleExpiringFilterChange = (value: any) => {
    setExpiringFilter(value);
    updateURLParams({ expiringFilter: value });
    // The useEffect will handle the API call when expiringFilter changes
  };
  const handleISPChange = (value: string) => {
    const ispValue = value || null;
    setSelectedISP(ispValue);
    updateURLParams({ isp: ispValue });
  };

  const handleAreaChange = (value: string) => {
    const areaValue = value || null;
    setSelectedArea(areaValue);
    setSelectedSubArea(null);
    updateURLParams({ area: areaValue, subArea: null });
    if (value) {
      getSubAreasApi({ intPkAreaID: Number(value) });
    } else {
      setSubAreas([]);
    }
  };

  const handleSubAreaChange = (value: string) => {
    const subAreaValue = value || null;
    setSelectedSubArea(subAreaValue);
    updateURLParams({ subArea: subAreaValue });
  };

  const handlePendingPaymentsFilterChange = (e: any) => {
    const checked = e.target.checked;
    setPendingPaymentsFilter(checked);
    updateURLParams({ pendingPayments: checked ? "true" : null });
  };

  const getFilters = () => {
    const filters: any = {};
    if (selectedISP) filters.intPkIspID = Number(selectedISP);
    if (selectedSubArea) {
      filters.intPkAreaID = Number(selectedSubArea);
    } else if (selectedArea) {
      filters.intPkAreaID = Number(selectedArea);
    }
    if (pendingPaymentsFilter) {
      filters.pendingPayments = true;
    }
    return filters;
  };

  const handleAllUsersPageSwitch = (pageNumber: number) => {
    setCurrentPage(pageNumber);
    updateURLParams({ page: String(pageNumber) });
    // useEffect will handle the API call
  };
  const handleAllUsersPageSizeChange = (page: number, size: number) => {
    setPageSize(size);
    setCurrentPage(1);
    updateURLParams({ pageSize: String(size), page: "1" });
    // useEffect will handle the API call
  };
  const handleExpiringUsersPageSwitch = (pageNumber: number) => {
    setExpiringCurrentPage(pageNumber);
    // useEffect will handle the API call
  };
  const handleExpiringUsersPageSizeChange = (page: number, size: number) => {
    setExpiringPageSize(size);
    setExpiringCurrentPage(1);
    // useEffect will handle the API call
  };
  const handleExpiredUsersPageSwitch = (pageNumber: number) => {
    setExpiredCurrentPage(pageNumber);
    // useEffect will handle the API call
  };
  const handleExpiredUsersPageSizeChange = (page: number, size: number) => {
    setExpiredPageSize(size);
    setExpiredCurrentPage(1);
    // useEffect will handle the API call
  };
  const handleSearch = (search: string, type: number) => {
    if (search.trim() === "") {
      setIsSearch(false);
      setSearchTerm("");
      return;
    }
    if (search.length < 3) {
      return;
    }
    setIsSearch(true);
    setSearchTerm(search);
    const searchFilters: any = { search };
    if (pendingPaymentsFilter) {
      searchFilters.pendingPayments = true;
    }
    postSearchAPi(searchFilters);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value.trim() === "") {
      setIsSearch(false);
    }
  };

  // Debounced search effect
  useEffect(() => {
    const delaySearch = setTimeout(() => {
      if (searchTerm.trim() !== "" && searchTerm.length >= 3) {
        handleSearch(searchTerm, Number(usersFilter));
      } else if (searchTerm.trim() === "") {
        setIsSearch(false);
      }
    }, 500);

    return () => clearTimeout(delaySearch);
  }, [searchTerm]);

  const getTableTitle = () => {
    const activeFilter = Number(usersFilter);
    if (activeFilter === 1) {
      return `All Connections (${
        isSearch ? searchedUsers.length : pagination.totalCount
      })`;
    } else if (activeFilter === 2) {
      return `Expiring Connections (${
        isSearch ? searchedUsers.length : expiringPagination.totalCount
      })`;
    } else if (activeFilter === 3) {
      return `Expired Connections (${
        isSearch ? searchedUsers.length : expiredPagination.totalCount
      })`;
    }
    return "";
  };
  useEffect(() => {
    if (searchApiResponse !== null) {
      const data: any = searchApiResponse.responseData;
      const allResults =
        data.map((item: any): CompanyConnection => {
          return {
            ...item,
            fullName: `${item.firstName} ${item.lastName}`,
          };
        }) || [];

      const activeFilter = Number(usersFilter);
      if (activeFilter === 1) {
        // All Connections tab
        setSearchedUsers(allResults);
      } else if (activeFilter === 2) {
        // Expiring Connections tab - filter by expiring dates
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const filterValue = Number(expiringFilter);
        let maxDate = new Date();

        if (filterValue === 1) {
          // Today
          maxDate = new Date(today);
          maxDate.setDate(maxDate.getDate() + 1);
        } else if (filterValue === 2) {
          // Tomorrow
          maxDate = new Date(today);
          maxDate.setDate(maxDate.getDate() + 2);
        } else if (filterValue === 3) {
          // This week
          maxDate = new Date(today);
          maxDate.setDate(maxDate.getDate() + 7);
        } else {
          // All expiring (default: 7 days)
          maxDate = new Date(today);
          maxDate.setDate(maxDate.getDate() + 7);
        }

        const expiringResults = allResults.filter((item: any) => {
          if (!item.expiryDate) return false;
          const expiryDate = new Date(item.expiryDate);
          expiryDate.setHours(0, 0, 0, 0);
          return expiryDate >= today && expiryDate <= maxDate;
        });

        setSearchedUsers(expiringResults as any);
      } else if (activeFilter === 3) {
        // Expired Connections tab - filter by expired dates
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const expiredResults = allResults.filter((item: any) => {
          if (!item.expiryDate) return false;
          const expiryDate = new Date(item.expiryDate);
          expiryDate.setHours(0, 0, 0, 0);
          return expiryDate < today;
        });

        setSearchedUsers(expiredResults as any);
      }
    }
  }, [searchApiResponse, usersFilter, expiringFilter]);
  const connectionOptionItems: MenuProps["items"] = [
    {
      key: "CATV",
      label: (
        <Typography className="profile-drop-down-item">
          <img src={CATVBlue} />
          Create CATV Connection
        </Typography>
      ),
    },
    {
      key: "INTERNET",
      label: (
        <Typography className="profile-drop-down-item">
          <img src={WifiIcon} />
          Create Internet Connection
        </Typography>
      ),
    },
  ];
  const handleMenuClick = (e: any) => {
    if (e.key === "INTERNET") {
      //intPkHeadID
      navigate(`/connections/create-internet`);
    } else if (e.key === "CATV") {
      navigate(`/connections/create-catv`);
    }
  };
  return (
    <>
      <Row gutter={16} style={{ alignItems: "center" }}>
        <Col span={18} className="dashboard-select-options-container">
          <NetwalaSelect
            size="large"
            height="40px"
            onChange={handleChange}
            options={options}
            value={usersFilter}
            isStandardSelectedColor
            showSearch
          />
          {Number(usersFilter) === 2 ? (
            <NetwalaSelect
              size="large"
              height="40px"
              onChange={handleExpiringFilterChange}
              options={secondOptions}
              value={expiringFilter}
              isStandardSelectedColor
              showSearch
            />
          ) : null}
          <NetwalaSelect
            size="large"
            height="40px"
            onChange={handleISPChange}
            options={isps}
            value={selectedISP || ""}
            placeHolder="Select ISP"
            isStandardSelectedColor
            showSearch
          />
          <NetwalaSelect
            size="large"
            height="40px"
            onChange={handleAreaChange}
            options={areas}
            value={selectedArea || ""}
            placeHolder="Select Area"
            isStandardSelectedColor
            showSearch
          />
          {subAreas.length > 0 && (
            <NetwalaSelect
              size="large"
              height="40px"
              onChange={handleSubAreaChange}
              options={subAreas}
              value={selectedSubArea || ""}
              placeHolder="Select Sub Area"
              isStandardSelectedColor
              showSearch
            />
          )}
          <Checkbox
            checked={pendingPaymentsFilter}
            onChange={handlePendingPaymentsFilterChange}
            style={{ marginLeft: "10px",textWrap:"nowrap" }}
          >
           <p style={{lineHeight:"10px"}}> Pending Payments</p>
          </Checkbox>
        </Col>
        <Col
          span={6}
          className="create-user-dashboard-button-container"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Dropdown
            menu={{
              items: connectionOptionItems,
              onClick: handleMenuClick,
            }}
            placement="bottomLeft"
          >
            <img className="cursor-pointer" style={{height:"40px",width:"auto"}} src={NewConnectionIcon} />
            {/* <img className="cursor-pointer" src={OptionsIcon} /> */}
          </Dropdown>
        </Col>
      </Row>
      <Row gutter={[16, 16]} className="mt-20">
        <Col span={24}>
          <div
            className="users-search-container"
            style={{ marginBottom: "16px" }}
          >
            <Typography className="netwala-user-tables-heading" >
              {getTableTitle()}
            </Typography>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <Search
                className="custom-search-input"
                placeholder="Name / Username / phone Number"
                onSearch={(value) => {
                  if (value.trim() !== "" && value.length >= 3) {
                    handleSearch(value, Number(usersFilter));
                  }
                }}
                value={searchTerm}
                allowClear
                onChange={handleSearchChange}
                style={{ width: 300 }}
              />
            </div>
          </div>
          {getActiveUsersTable(Number(usersFilter))}
          {/* <NetwalaUsersTable users={users} /> */}
        </Col>
      </Row>
    </>
  );
};
export default CustomersComponent;
